/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-inferrable-types */
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'sml-toggle-button',
  imports: [CommonModule],
  templateUrl: './toggle-button.component.html',
  styleUrl: './toggle-button.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: ToggleButtonComponent,
      multi: true
    }
  ]
})
export class ToggleButtonComponent implements ControlValueAccessor {
  @Input() value: boolean = false; // Initial value of the toggle
  @Input() groupidentifier = '';
  @Input() isDisabled: boolean = false; // Input to control disabled state
  @Input() isCalledFromBuildCampaign: boolean = false; // Input to control conditional styling
  
  // ControlValueAccessor methods
  onChange(event: Event): void {
    const input = event.target as HTMLInputElement; // Type-casting to HTMLInputElement
    if (input) {
      this.value = input.checked;  // Access checked property safely
      this.propagateChange(this.value);
    }
  }
  // Placeholder for ControlValueAccessor
  onTouched = () => {};

  propagateChange = (_: any) => {};

  writeValue(value: boolean): void {
    if (value !== undefined) {
      this.value = value;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }



  
}
